import { __exports as wellKnownSymbolWrapped } from '../../../../../../_virtual/well-known-symbol-wrapped.js';
import { w as wellKnownSymbol$1 } from './well-known-symbol.js';

var wellKnownSymbol = wellKnownSymbol$1;

wellKnownSymbolWrapped.f = wellKnownSymbol;

export { wellKnownSymbolWrapped as default };
